import Skeleton from 'react-loading-skeleton'
import styles from 'components/NewsCard/NewsCard.module.sass'

const NewsLoading = () => (
  <div className={styles.card}>
    <div style={{ width: '-webkit-fill-available' }}>
      <Skeleton height={25} style={{ marginBottom: '9px' }} />
      <Skeleton height={20} count={2} style={{ marginBottom: '11px' }} />
      <Skeleton height={15} count={3} />
    </div>
  </div>
)

export default NewsLoading
